import { TAssetAction } from './assets';
import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';

export type TModalState = {
  position: { x: number; y: number };
  size: { width: number; height: number };
  isMinimized: boolean;
};

export type AddToSceneModalProps = {
  open: boolean;
  onClose: () => void;
  setSelectableAssets: (action: TAssetAction) => void;
  userEmail: string;
  worlds?: any;
  selectedWorld?: any;
  buildScene?: any;
  session?: any;
  selectedSceneTemplate?: any;
  loadScene?: (
    name: string,
    url: string,
    type: SIDE_MENU_EVENTS,
    sceneThumbnail: string
  ) => void;
  camera?: any;
};

export type TAssetInput = {
  type: string;
  name?: string;
  url?: string;
  metadata?: {
    type?: string;
    [key: string]: any;
  };
  [key: string]: any;
};

export type TModalSize = {
  width: number;
  height: number;
};

export type TModalConfig = {
  DEFAULT_SIZE: TModalSize;
  MIN_SIZE: TModalSize;
  MAX_SIZE: TModalSize;
  NAVBAR_HEIGHT: number;
};

export const MODAL_CONFIG: TModalConfig = {
  DEFAULT_SIZE: { width: 1125, height: 700 },
  MIN_SIZE: { width: 450, height: 300 },
  MAX_SIZE: { width: 1125, height: 700 },
  NAVBAR_HEIGHT: 64,
} as const;
